namespace $ {
	const { rem } = $mol_style_unit

	$mol_style_define($.$$.$bog_ainews_app_feed_img, {
		display: 'block',
		objectFit: 'cover',
		borderRadius: rem(0.5),
		boxShadow: '0 2px 8px rgba(0,0,0,.08)',
	})
}
